import React, { useContext, useEffect, useState } from 'react';
import "./CreatProject.css";
import Application from '../../../StateContext/Application.js';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages.js';
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext.js';
import GooglePagination from '../../../styles/GooglePagination.js';
import validateFile from '../../../../../utils/fileUploadHelper.js';

const CreateProject = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const operation = useContext(Application);
  const { GRCreation, GetBudgetHeadInfo, SecureFileFetching, CheckGRNumberFunction, Usermenu, GetMyDepartmentAccess } = operation;

  const [show, setShow] = useState(false);
  const [HeadInfo, setHeadInfo] = useState([]);
  const [Grampanchyat, setGramPanchayat] = useState([]);
  // const [testingData, setTestingData] = useState([]);
  const [testingData, setTestingData] = useState([]);
  const [tableContainer, setTableContianer] = useState([]);
  const [selectedProposalId, setSelectedProposalId] = useState(null);
  const [selectedProposals, setSelectedProposals] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  console.log("Praposal Data i get :: ", testingData);
  console.log("Tablecontainer Data i get :: ", tableContainer);

  const [grError, setGrError] = useState("");
  const [saveButtonDisable, setSaveButtonDisable] = useState(false);

  const billsPerPage = 10;
  const totalPages = Math.ceil(tableContainer.length / billsPerPage);

  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  //  const sortedBills = Array.isArray(tableContainer)? tableContainer.slice() // ✅ prevent state mutation
  //       .sort((a, b) => new Date(b.Approvance3Date) - new Date(a.Approvance3Date)): [];
  const sortedBills = Array.isArray(tableContainer)
    ? tableContainer
      .slice() // ✅ prevent state mutation
      .sort((a, b) => {
        const dateA = new Date(a.Approvance3Date || a.Approvance6Date || 0);
        const dateB = new Date(b.Approvance3Date || b.Approvance6Date || 0);
        return dateB - dateA; // latest first
      })
    : [];

  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = tableContainer.slice(indexOfFirstBill, indexOfLastBill);
  const [selectAll, setSelectAll] = useState(false);

  const [RoleID, setroleID] = useState(null)
  const [data, setData] = useState({
DepartmentAccessID: "",     // नवीन
    HeadCode: "",
    ProposalYear: "",
    ZillaParishad: "",
    GRNumber: "",
    EFileNo:"",
    GRDate: ""
  });
    const [myDepartments, setMyDepartments] = useState([]);
    const [departmentsLoaded, setDepartmentsLoaded] = useState(false);

const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID)
      console.log("sffdsf", roleID)
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };

  useEffect(() => {
    // FetchHeadInfo();
    FetchGramPanachayatInfo();
    FetchHeadInfo();
    setCurrentPage(1);
    getmenu()
  }, []);

      useEffect(() => {
      (async () => {
        try {
          const r = await GetMyDepartmentAccess();
          const list = r?.data?.departments || [];
          setMyDepartments(list);
          if (list.length === 1) {   // एकच विभाग असेल तर आपोआप
            setData((prev) => ({ ...prev, DepartmentAccessID: String(list[0].id) }));
          }
        } catch (e) {
          console.error("GetMyDepartmentAccess failed", e);
        } finally {
          setDepartmentsLoaded(true);
        }
      })();
    }, []);

  const CheckGRNo = async (grNumber) => {
    try {
      if (!grNumber) return;

      const res = await CheckGRNumberFunction(grNumber);
      const { status, message } = res;

      console.log("GR Check Response --> ", res);

      if (status) {
        // ❌ GR Number already exists
        setGrError(message);
        setSaveButtonDisable(true);

        setData(prev => ({
          ...prev,
          // GRNumber: "",
          GRDate: "",
          Taluka: ""
        }));

      } else {
        // ✅ GR Number available
        setGrError("");
        setSaveButtonDisable(false);
      }

    } catch (err) {
      console.error("Check GR Error :: ", err);
    }
  };

  const HandleChangeData = (e) => {
    const { name, value } = e.target;

    if (value.length === 1 && value[0] === " ") return;
    setData({ ...data, [name]: value });

    if (name === "HeadCode") {
      setData(prev => ({
        ...prev,
        ProposalYear: "",
        ZillaParishad: "",
        Taluka: "",
        GRDate: "",
        GRNumber: "",
        EFileNo:"",
      }));
      setTotalAmount(0)
      setShow(false)
      document.getElementById("GRCopy").value = "";
    }

    else if (name === "ProposalYear") {
      setData(prev => ({
        ...prev,
        ZillaParishad: "",
        Taluka: "",
        GRDate: "",
        GRNumber: "",
        EFileNo:"",
      }));
      setTotalAmount(0)
      setShow(false)
      document.getElementById("GRCopy").value = "";
    }

    else if (name === "ZillaParishad") {
      setData(prev => ({
        ...prev,
        Taluka: "",
        GRDate: "",
        GRNumber: "",
        EFileNo:"",
      }));
      setTotalAmount(0)
      setShow(false)
      document.getElementById("GRCopy").value = "";
    }

    setSelectedProposalId(null);
  };


      const handleDepartmentChange = (e) => {
    const id = e.target.value;
    setData((prev) => ({
      ...prev,
      DepartmentAccessID: id,
      ProposalYear: "",
      ZillaParishad: "",
      Taluka: "",
      GRDate: "",
      GRNumber: "",
      EFileNo: "",
    }));
    setTotalAmount(0);
    setShow(false);
    setSelectedProposalId(null);
    setSelectedProposals([]);
    const f = document.getElementById("GRCopy");
    if (f) f.value = "";
  };


  const formData = new FormData();

  const handleSubmit = async (e, condition) => {
    e.preventDefault();

    if (selectedProposals.length <= 0) {
      return alert("No proposal Selected !!!");
    };

    let GRCopy = document.getElementById("GRCopy").files;
        if (departmentsLoaded && myDepartments.length > 0 && !data.DepartmentAccessID) {
      return alert("Please select Department !!!");
    }

    if (
      !data.GRNumber ||
      !data.GRDate ||
      !data.HeadCode ||
      !data.ProposalYear ||
      !data.ZillaParishad||
      !data.EFileNo
    ) {
      return alert("Data is missing  !!!");
    };
    const grCheckRes = await CheckGRNumberFunction(data.GRNumber);

    if (grCheckRes?.status) {
      // GR already exists
      alert(grCheckRes.message || "GR Number already exists");
      return;
    }
    setLoading(true);

    try {
      for (const key in data) {
        formData.append(key, data[key]);
      }
      formData.append("GRCopy", GRCopy[0]);
      formData.append("selectedProposal", JSON.stringify(selectedProposals));
      formData.append("GRAmount", totalAmount);
      formData.append("condition", condition);

      let result = await GRCreation(formData);
      console.log(result);
      alert(result);
      window.location.reload();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const FetchHeadInfo = async () => {
    try {
      let res1 = await GetBudgetHeadInfo("null", "GetALLProposalData");
      console.log("1353 in API response?", res1.filter(r => r.JOB_ID == 1353));
console.log("Total rows from API:", res1.length);
      let res2 = await GetBudgetHeadInfo("null", "AllHeadCode");
      console.log("Data i get from Bakcend :: ", res2);
      setHeadInfo(res2);
      setTestingData(res1);
    }
    catch (err) {
      console.log(err);
    }
  };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "GetTalukas");
      // console.log("Data i get:: ", res);
      setGramPanchayat(res);
    }
    catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (!RoleID) return;

    setData(prev => ({
      ...prev,
      HeadCode:
        RoleID === 25 || RoleID === 24
          ? "3054-2419(Roads and bridge repair maintenance program)"
          : "2515-1238(MLA Representative)"
    }));
  }, [RoleID]);

  // useEffect(() => {
  //   // FetchHeadInfo();
  //   FetchGramPanachayatInfo();
  //   FetchHeadInfo();
  //   setCurrentPage(1);
  // }, []);

  const FetchDataRelatedtoZilla = async (id) => {
    setShow(true);
    try {
      let res = await GetBudgetHeadInfo(id, "GetSpecificTaluka");
      console.log(res);
      setTestingData(res);
      setTestingData(res);
    }
    catch (err) {
      console.log(err);
    }
  };

  // const fetchRightData = async () => {
  //   try {
  //     let res1 = await GetBudgetHeadInfo(data., "GetALLProposalData");
  //     setTableContianer(res1);
  //   }
  //   catch (err) {
  //     console.log(err);
  //   }
  // }

  useEffect(() => {
    console.log("-------", testingData);
    console.log("-------", data);


    if (testingData && testingData.length > 0) {

      if (data.HeadCode && data.ProposalYear && data.ZillaParishad) {
        console.log("FILTER CONDITIONS: ", {
          HeadCode: data.HeadCode,
          ProposalYear: data.ProposalYear,
          ZillaParishad: data.ZillaParishad,
        });

        let update = testingData.filter(
          (item) =>
            item?.HeadCode == data.HeadCode
            && item?.Proposal_year == data.ProposalYear
            && item?.District == data.ZillaParishad
        );
        console.log("Result data filtered i get :: ", update);
        setShow(true);
        setTableContianer(update);
      }
    }

  }, [data.HeadCode, data.ProposalYear, data.ZillaParishad]);

  useEffect(() => {
    if (testingData?.length > 0 && data.HeadCode && data.ProposalYear && data.ZillaParishad) {
      const update = testingData.filter((item) => {
        const matchHead = item.HeadCode?.trim() === data.HeadCode?.trim();
        const matchYear = item.Proposal_year?.trim() === data.ProposalYear?.trim();
        const matchDistrict = item.District?.trim() === data.ZillaParishad?.trim();
        return matchHead && matchYear && matchDistrict;
      });

      console.log("Filtered Result:", update);
      setShow(update.length > 0);
      setTableContianer(update);
    }
  }, [data.HeadCode, data.ProposalYear, data.ZillaParishad, testingData]);

  useEffect(() => {
    if (!data.GRNumber || data.GRNumber.length < 3) {
      setGrError("");
      return;
    }

    const timer = setTimeout(() => {
      CheckGRNo(data.GRNumber);
    }, 300); // wait until user stops typing

    return () => clearTimeout(timer);
  }, [data.GRNumber]);

  // useEffect(() => {
  //   if (testingData && testingData.length > 0) {
  //     let update = testingData.filter((item) => item?.HeadCode == data.HeadCode && item?.Proposal_year == data.ProposalYear && item?.District == data.ZillaParishad);
  //     console.log("Result data filtered i get :: ", update);
  //     setTableContianer(update);
  //   }
  // }, [data.HeadCode, data.ProposalYear, data.ZillaParishad]);

  const SortByProposalYear = (year) => {
    let res = testingData.filter((item) => item.Proposal_year === year);
    // let res = testingData.filter((item) => item.Proposal_year === year);
    setTableContianer(res);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      // Add ALL currentBills to selectedProposals
      const allSelected = currentBills.map(proposal => ({
        ...proposal
      }));
      setSelectedProposals(allSelected);

      // Calculate total amount
      const total = currentBills.reduce((sum, p) => sum + Number(p.Proposal_amount), 0);
      setTotalAmount(total);
    } else {
      // Uncheck all
      setSelectedProposals([]);
      setTotalAmount(0);
    }
  };

  // const handleCheckboxChange = (e, proposal) => {
  //   const isChecked = e.target.checked;

  //   const selectedEntry = {
  //     ProposalID: proposal.ProposalID,
  //     Proposal_amount: proposal.Proposal_amount,
  //     Taluka: proposal.Taluka,
  //     Work_name: proposal.Work_name
  //   };

  //   if (isChecked) {

  //     setSelectedProposals(prev => [...prev, selectedEntry])
  //     setTotalAmount(prev => prev + Number(proposal.Proposal_amount));
  //   } else {
  //     setSelectedProposals(prev => prev.filter(p => p.ProposalID !== proposal.ProposalID));
  //     setTotalAmount(prev => prev - Number(proposal.Proposal_amount));
  //   }
  // };

  const handleCheckboxChange = (e, proposal) => {
    const isChecked = e.target.checked;
    const amount = Number(proposal.Proposal_amount);

    setSelectedProposals(prev => {
      let updatedSelected;

      if (isChecked) {
        updatedSelected = [...prev, proposal];
      } else {
        updatedSelected = prev.filter(
          p => p.ProposalID !== proposal.ProposalID
        );
      }

      setSelectAll(updatedSelected.length === currentBills.length);
      return updatedSelected;
    });

    // ✅ Safe: runs once per click
    setTotalAmount(prev =>
      isChecked ? prev + amount : prev - amount
    );
  };

  useEffect(() => {
    setSelectedProposals([]);
    setSelectAll(false);
    setTotalAmount(0);
  }, [data.ZillaParishad]);

  const handleFileUpload = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    const validation = validateFile(file, 2);
 
    if (!validation.valid) {
        alert(validation.message);
        e.currentTarget.value = "";
        return;
    }
  };

  const filteredTestingData = testingData.filter(
    item =>
      item?.HeadCode === data.HeadCode &&
      item?.Proposal_year === data.ProposalYear &&
      item?.District === data.ZillaParishad
  );

  const proposalSummary = Object.values(
    filteredTestingData.reduce((acc, item) => {
      const key = item.workuniqueid;

      if (!acc[key]) {
        acc[key] = {
          workuniqueid: key,
          Proposal_fileNumber: item.Proposal_fileNumber,
          Proposal_year: item.Proposal_year,
          HeadCode: item.HeadCode,
          District: item.District,
          Approvance3Date: item.Approvance3Date || item.Approvance6Date,
          Taluka: item.Taluka,
          LatestCreatedDate: item.LatestCreatedDate,
          TotalWorks: 0,
        };
      }

      // ✅ keep latest created_at
      if (new Date(item.Approvance3Date) > new Date(acc[key].Approvance3Date)) {
        acc[key].Approvance3Date = item.Approvance3Date;
      }

      acc[key].TotalWorks += 1;
      return acc;
    }, {})
  ).sort((a, b) => new Date(b.Approvance3Date) - new Date(a.Approvance3Date));   // ✅ newest first

  const proposalTotalPages = Math.ceil(
  proposalSummary.length / billsPerPage
);
 
const currentProposals = proposalSummary.slice(
  indexOfFirstBill,
  indexOfLastBill
);


  const handleViewProposal = (id) => {
    const works = testingData.filter(
      item => item.workuniqueid === id &&
        item?.HeadCode === data.HeadCode &&
        item?.Proposal_year === data.ProposalYear &&
        item?.District === data.ZillaParishad
    );

    setTableContianer(works);
    setSelectedProposalId(id);
    setCurrentPage(1);
  };

  const getAdministrativeYears = () => {
    const startYear = 2025;
    const currentYear = new Date().getFullYear();

    let years = [];

    for (let year = startYear; year <= currentYear; year++) {
      years.push(`${year}-${year + 1}`);
    }

    return years;
  };

  return (
    <>
      <div style={{ height: '90vh', overflowY: 'auto' }}>
        <div className="col-12" style={{ backgroundColor: "#EFF3F8", padding: '2rem 0px 5px 0px', overflowX: "hidden" }}>

          <div className="col-12 m-auto my-5 budgetContainer">

            <div className="m-auto budgetElement">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                <div>
                  <h5 className=' bg-light'><img src={ProposalCreation32} />{t("Create GR")}</h5>
                </div>
                {/* <div>
              {/* <div>
                <img src={Back32} />
              </div> </div> */}
              </div>
              <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>{t("Note : Fields marked with * are mandatory")}</p>

              {loading && (
                <div
                  style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}>
                  <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )}

              <div className="budgetElement2">
                <form action="">

  {myDepartments.length > 1 && (
  <div className="col-12 elements">
    <div className="row">
      <div className="col-5">
        <label>
          {t("Department")} <span className="text-danger fw-bold">*</span>
        </label>
      </div>
      <div className="col-7">
        <select
          name="DepartmentAccessID"
          value={data.DepartmentAccessID}
          className="py-2"
          onChange={handleDepartmentChange}
        >
          <option value="" disabled>{t("Select Department")}</option>
          {myDepartments.map((d) => (
            <option key={d.id} value={d.id}>{d.name}</option>
          ))}
        </select>
      </div>
    </div>
  </div>
)}


                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>{t("Head Code")} <span className='text-danger fw-bold'>*</span></label>
                      </div>
                      <div className="col-7">
                        {/* <select name="HeadCode" value={data.HeadCode} className='py-2' onChange={HandleChangeData}>
                          <option value="">{t("Select Head")}</option>
                          {
                            HeadInfo && (
                              HeadInfo.map((val, index) => {
                                return (
                                  <option value={val.HeadID} >{val.HeadName}</option>
                                )
                              })
                            )
                          }
                        </select> */}
                        <select name="HeadCode" value={data.HeadCode} className='py-2' onChange={HandleChangeData}>
                          {HeadInfo &&
                            HeadInfo
                              .filter(val =>
                                RoleID === 25 || RoleID === 24
                                  ? val.HeadName === "3054-2419(Roads and bridge repair maintenance program)"
                                  : val.HeadName === "2515-1238(MLA Representative)"
                              )
                              .map(val => (
                                <option key={val.HeadID} value={val.HeadID}>
                                  {val.HeadName}
                                </option>
                              ))
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>{t("Approved Year")} <span className='text-danger fw-bold'>*</span></label>
                      </div>
                      <div className="col-7">
                        {/* <input type="text" name="ProposalYear" value={data.ProposalYear} className='py-2'  disabled></input> */}
                        <select name="ProposalYear" value={data.ProposalYear} className='py-2' onChange={(e) => {
                          HandleChangeData(e);
                          // SortByProposalYear(e.target.value)
                          // SortByProposalYear(e.target.value)
                        }}>
                          <option value="">{t("Select Proposal Year")}</option>
                          {getAdministrativeYears().map((year, index) => (
                            <option key={index} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>{t("Zilla Parishad")} <span className='text-danger fw-bold'>*</span></label>
                      </div>
                      <div className="col-7">
                        {/* <select name="ZillaParishad" value={data.ZillaParishad} className='py-2' onChange={(e) => {
                        HandleChangeData(e);
                        FetchDataRelatedtoZilla(e.target.value);
                      }
                      }>
                        <option value="">Select Zilla Parishad</option>
                        {
                          Grampanchyat &&
                          [...new Set(Grampanchyat.map(val => val.District))].map((district, index) => (
                            <option value={district} key={index}>{district}</option>
                          ))
                        }
 
 
                      </select> */}
                        <select
                          name="ZillaParishad"
                          value={data.ZillaParishad}
                          className="py-2"
                          onChange={(e) => {
                            const selectedDistrict = e.target.value;
                            HandleChangeData(e);

                            // Get all ULBNames (talukas) related to selected district
                            const relatedTalukas = Grampanchyat
                              .filter(val => val.District === selectedDistrict)
                              .map(val => val.ULBName);
                            // Optionally set first taluka as default
                            if (relatedTalukas.length > 0) {
                              setData(prev => ({ ...prev, Taluka: relatedTalukas[0] }));
                            }
                          }}
                        >
                          <option value="">{t("Select Zilla Parishad")}</option>

                          {
                            Grampanchyat &&
                            [...new Set(
                              Grampanchyat
                                .filter(val => val.District_Marathi != null && val.District_Marathi !== '')
                                .map(val => val.District_Marathi)
                            )].map((District_Marathi, index) => (
                              <option value={District_Marathi} key={index}>
                                {District_Marathi}
                              </option>
                            ))
                          } {/* {
                            Grampanchyat &&
                            [...new Set(Grampanchyat.map(val => val.District_Marathi))].map((District_Marathi, index) => (
                              <option value={District_Marathi} key={index}>{District_Marathi}</option>
                            ))
                          } */}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5 my-auto">
                        <label className='my-auto'>{t("GR Number")} <span className='text-danger fw-bold'>*</span></label>
                      </div>
                      <div className="col-7">
                        <input type="text" placeholder={t("Enter GR Number")} className='form-control py-2' name='GRNumber'
                          value={data.GRNumber}
                          onChange={HandleChangeData} onBlur={(e) => {

                            CheckGRNo(e.target.value);
                            const value = e.target.value.trim();

                                                            // Check if at least ONE valid character exists
                                                            const hasValidChar = /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                                                            if (value && !hasValidChar) {
                                                                setError("Enter at least one valid character");
                                                                alert("Enter at least one valid character")
                                                                setTimeout(() => e.target.focus(), 0);
                                                            } else {
                                                                setError("");
                                                            }}
                          }
                          
                  
                           />
                        {grError && (
                          <p style={{ color: "red", fontSize: "13px", marginTop: "1px" }}>
                            {grError}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* E file no  */}

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5 my-auto">
                        <label className='my-auto'>{t("E File Number")} <span className='text-danger fw-bold'>*</span></label>
                      </div>
                      <div className="col-7">
                        <input type="text" placeholder={t("Enter E File Number")} className='form-control py-2' name='EFileNo'
                          value={data.EFileNo}
                          onChange={HandleChangeData} 
                          // onBlur={(e) => {

                          //   CheckGRNo(e.target.value);
                          // }}
                           />
                        {/* {grError && (
                          <p style={{ color: "red", fontSize: "13px", marginTop: "1px" }}>
                            {grError}
                          </p>
                        )} */}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>{t("GR Date")}<span className='text-danger fw-bold'>*</span></label>
                      </div>
                      <div className="col-7">
                        <input type="date" className='form-control py-2' value={data.GRDate} name='GRDate' onChange={HandleChangeData} onKeyDown={(e) => e.preventDefault()} required max={new Date().toLocaleDateString("en-CA")} />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5 my-auto">
                        <label className='my-auto'>{t("GR Amount")}</label>
                      </div>
                      <div className="col-7">
                        <input type="number" placeholder={t("Enter GR Amount")} className='form-control py-2'
                          value={Number(totalAmount || 0).toFixed(2)}
                          onChange={HandleChangeData}
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-5">
                        <label>{t("Supporting File ( Optional )")}</label>
                      </div>
                      <div className="col-7">
                        <input type="file" className='form-control py-2' id='GRCopy' accept=".pdf,.jpg,.jpeg,.png" onChange={handleFileUpload} />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 ms-auto my-4">
                    <div className="row">
                      <div className="col-3"></div>
                      <div className="col-8">
                        <div className="col-12" style={{ display: 'flex', gap: '10px' }}>
                          {/* <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '10rem', height: '2rem', fontSize: '18px' }} onClick={(e) => { handleSubmit(e, "Draft") }}><img src={submit} style={{ width: '10px' }} /> Save As Draft</button> */}
                          <button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', background: 'linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)', width: '8rem', height: '2rem', fontSize: '16px' }} onClick={(e) => { handleSubmit(e, "Submitted") }}><img src={submit} style={{ width: '15px' }} />{t("Submit")}</button>
                          <button type="button" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', backgroundColor: '#f1094c', width: '8rem', height: '2rem', fontSize: '16px' }} onClick={() => window.location.reload()}><img src={Cancel32} style={{ width: '17px' }} /> {t("Cancel")}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>


          {

            show &&
            <div className="col-12" style={{ backgroundColor: "#EFF3F8", overflowX: "hidden", overflowY: "scroll" }}>

              <div className="col-11 m-auto">
                <div className="col-12">

                  <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                    <h5 className='my-auto fw-bold' >
                      <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                      <span className='my-auto'>GR Creation List</span>
                    </h5>
                    {/* <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                      <img
                        src="/Search32.png"
                        alt="Search Icon"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          width: "16px",
                          height: "16px",
                          opacity: 0.6
                        }}
                      />
                      <input
                        type="text"
                        placeholder="Search Here"
                        onChange={(e) => setSearchTerm(e.target.value)}
                        value={searchTerm}
                        style={{
                          width: "100%",
                          padding: "8px 12px 8px 32px", // left padding makes space for icon
                          border: "1px solid #ccc",
                          borderRadius: "8px",
                          backgroundColor: "#f1f6fc",
                          fontSize: "14px",
                          color: "#333",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                          outline: "none"
                        }}
                      />
                    </div> */}
                  </div>

                  {/* TABLE CARD */}
                  {!selectedProposalId && (
                    <div className="col-12 pb-5">
                      <div
                        className="m-auto mb-3"
                        style={{
                          backgroundColor: "white",
                          padding: "40px 40px",
                          boxShadow: "0px 0px 5px 1px #E4E8EC",
                          borderRadius: "20px",
                        }}
                      >
                        <div
                          className="col-12 tableDesign"
                          style={{ background: "#2C78DB", overflowX: "scroll" }}
                        >
                          <table
                            className="m-0 p-0 GRStantionWorkstatusReport"
                            style={{ width: "100%", borderCollapse: "collapse" }}
                          >
                            <thead>
                              {/* Your existing table header */}
                              <tr
                                style={{
                                  color: "white",
                                  border: "none",
                                  height: "3rem",
                                  fontSize: "18px",
                                  fontWeight: "400",
                                }}
                              >
                                <th
                                  style={{ minWidth: "50px", padding: "2px" }}
                                  rowSpan={2}
                                >
                                  {t("Sr No")}
                                </th>
                                <th
                                  style={{ minWidth: "150px", padding: "8px" }}
                                  rowSpan={2}
                                >
                                  {t("Proposal File No")}
                                </th>

                                <th
                                  style={{ minWidth: "150px", padding: "8px" }}
                                  rowSpan={2}
                                >
                                  {t("Proposal Year")}
                                </th>
                                <th
                                  style={{ minWidth: "150px", padding: "8px" }}
                                  rowSpan={2}
                                >
                                  {t("District")}
                                </th>
                                <th
                                  style={{ minWidth: "150px", padding: "8px" }}
                                  rowSpan={2}
                                >
                                  {t("Date")}
                                </th>
                                <th
                                  style={{ minWidth: "100px", padding: "4px" }}
                                  rowSpan={2}
                                >
                                  {t("Total No of Work")}
                                </th>
                                <th
                                  style={{ minWidth: "150px", padding: "8px" }}
                                  rowSpan={2}
                                >
                                  {t("View")}
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              <>
                                {currentProposals.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan={8}
                                      style={{ textAlign: "center", padding: "10px" }}
                                    >
                                      {t("No data available")}
                                    </td>
                                  </tr>
                                ) : (
                                  currentProposals.map((proposal, index) => (
                                    <tr
                                      key={index}
                                      style={{
                                        backgroundColor:
                                          index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                                        fontSize: "16px",
                                        fontWeight: "400",
                                      }}
                                    >
                                      {/* Sr No */}
                                      <td style={{ padding: "8px 8px" }}>
                                        {indexOfFirstBill + index + 1}
                                      </td>

                                      {/* File Number */}
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Proposal_fileNumber}
                                      </td>

                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.Proposal_year}
                                      </td>

                                      {/* District */}
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.District}
                                      </td>

                                      {/* Created Date */}
                                  <td>
  {proposal.Approvance3Date
    ? new Date(
        proposal.Approvance3Date.replace(" ", "T") + "Z"
      ).toLocaleString("en-GB", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
    : "-"}
</td>

                                      {/* Total Proposals Count */}
                                      <td
                                        style={{ padding: "8px 8px", textAlign: "center" }}
                                      >
                                        {proposal.TotalWorks}
                                      </td>

                                      {/* Button */}
                                      <td
                                        style={{ padding: "8px 8px", textAlign: "center" }}
                                      >
                                        <button
                                          className="btn btn-primary btn-sm"
                                          onClick={() => handleViewProposal(proposal.workuniqueid)}
                                        >
                                          View Works
                                        </button>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </>
                            </tbody>
                          </table>
                        </div>

                         <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              height: "4rem",
                              alignItems: "center",
                            }}
                            className="mt-3"
                          >
                            <div>
                              <p className="text-gray-600" style={{ fontSize: "16px" }}>
                                {t("Showing")}{" "}
                                {proposalSummary.length > 0
                                  ? indexOfFirstBill + 1
                                  : 0}{" "}
                                {t("to")}{" "}
                                {Math.min(indexOfLastBill, proposalSummary.length)}{" "}
                                {t("of")} {proposalSummary.length} {t("entries")}
                              </p>
                            </div>
 
                            <GooglePagination
                              currentPage={currentPage}
                              totalPages={proposalTotalPages}
                              onPageChange={setCurrentPage}
                            />
                          </div>

                        {/* PAGINATION
                      <div className="col-12 mt-4 mb-2">
                        <div className="row">
                          <div className="col-6">
                            <p className="text-gray-600" style={{ fontSize: "14px" }}>
                              {t("Showing")} {indexOfFirst + 1} {t("to")}{" "}
                              {Math.min(indexOfLast, filteredBills.length)} {t("of")}{" "}
                              {filteredBills.length} {t("entries")}
                            </p>
                          </div>
                          <div
                            className="col-6"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "end",
                            }}
                          >
                            <button
                              onClick={() => setCurrentPage(1)}
                              disabled={currentPage === 1}
                              style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid lightgrey",
                                cursor: "pointer",
                                fontSize: "20px",
                                width: "2rem",
                              }}
                            >
                              &laquo;
                            </button>
                            <button
                              onClick={() => setCurrentPage(currentPage - 1)}
                              disabled={currentPage === 1}
                              style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid lightgrey",
                                cursor: "pointer",
                                fontSize: "20px",
                                borderLeft: "none",
                                width: "2rem",
                              }}
                            >
                              &lt;
                            </button>
                            <button
                              style={{
                                background:
                                  "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                                color: "white",
                                cursor: "pointer",
                                fontSize: "20px",
                                width: "2.4rem",
                                border: "1px solid lightgrey",
                                borderLeft: "none",
                              }}
                            >
                              {currentPage}
                            </button>
                            <button
                              onClick={() => setCurrentPage(currentPage + 1)}
                              disabled={currentPage === totalPages || totalPages === 0}
                              style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid lightgrey",
                                cursor: "pointer",
                                fontSize: "20px",
                                borderLeft: "none",
                                width: "2rem",
                              }}
                            >
                              &gt;
                            </button>
                            <button
                              onClick={() => setCurrentPage(totalPages)}
                              disabled={currentPage === totalPages || totalPages === 0}
                              style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "1px solid lightgrey",
                                cursor: "pointer",
                                fontSize: "20px",
                                borderLeft: "none",
                                width: "2rem",
                              }}
                            >
                              &raquo;
                            </button>
                          </div>
                        </div>
                      </div> */}
                      </div>
                    </div>
                  )}

                  {selectedProposalId && (
                    <div className="col-12 pb-5">
                      <div className="col-12 mb-3" style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%" }}>

                        <button
                          className="btn btn-danger mb-3"
                          onClick={() => {
                            setSelectedProposalId(null);
                            setTableContianer([]);
                          }}
                        >
                          Back to Proposals
                        </button>

                        <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: "auto", maxWidth: "100%" }}>
                          <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "18px" }}>
                                <th style={{ width: "3%", textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={selectAll}
                                    className='my-auto'
                                    style={{ height: '1rem', width: '1rem' }}
                                  />
                                </th>
                                <th style={{ padding: "7px 10px", minWidth: "60px" }}>Sr.No.</th>
                                {/* <th style={{ width: "10%" }}>Proposal ID</th> */}
                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Work Name</th>
                                <th style={{ padding: "7px 10px", minWidth: "120px" }}>Job ID</th>
                                <th style={{ padding: "7px 10px", minWidth: "120px" }}>Approval Year</th>
                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Head Code</th>
                                <th style={{ padding: "7px 10px", minWidth: "120px" }}>Taluka</th>
                                <th style={{ padding: "7px 10px", minWidth: "120px" }}>Constituency Name</th>
                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Gram Panchayat</th>
                                <th style={{ padding: "7px 10px", minWidth: "120px" }}>Work Amount</th>
                                <th style={{ padding: "7px 10px", minWidth: "180px" }}>Approve Proposal Report</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentBills.length > 0 ? (
                                currentBills.map((val, index) => {
                                  const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                  return (
                                    <tr style={{ border: 'none', height: '3rem', backgroundColor: bgColor, fontSize: "16px", fontWeight: "500" }} key={index}>
                                      <td style={{ padding: '8px 8px' }}>
                                        <input
                                          type="checkbox"
                                          onChange={(e) => handleCheckboxChange(e, val)}
                                          checked={selectedProposals.some(item => item.ProposalID === val.ProposalID)}
                                        />
                                      </td>
                                      <td style={{ padding: '8px 8px' }}>{indexOfFirstBill + index + 1}</td>
                                      <td style={{ padding: '8px 8px' }}>{val.Work_name}</td>
                                      <td style={{ padding: '8px 8px' }}>{val.JOB_ID}</td>
                                      <td style={{ padding: '8px 8px' }}>{val.Proposal_year}</td>
                                      <td style={{ padding: '8px 8px' }}>{val.HeadCode}</td>
                                      <td style={{ padding: '8px 8px' }}>{val.Taluka}</td>
                                      <td style={{ padding: '8px 8px' }}>{val.Constituency_name}</td>
                                      <td style={{ padding: '8px 8px' }}>{val.Gram_panchayat}</td>
                                      {/* <td style={{ padding: '8px 8px' }}>{val.Work_name}</td> */}
                                      <td style={{ padding: '8px 8px' }}>{val.Proposal_amount}</td>
                                      <td className='px-3'>{
                                        val.ProposalReport ?
                                          (
                                            <>
                                              {/* <a href={`${apiurl}/WorkOrderDocsImages/${technicalInwards.CopyofWorkOrder}`} target='_blank'>{technicalInwards.CopyofWorkOrder}</a> */}
                                              <div className='m-auto' style={{ display: "flex", alignItems: "center", gap: "0.20rem", justifyContent: "center", width: "fit-content" }}>
                                                <img src="/pdf-32.png" alt="pdf" style={{ width: "1.3rem", height: "1.3rem" }} />
                                                <p
                                                  onClick={() => SecureFileFetching(`ProposalFile/${val.ProposalReport}`)}
                                                  style={{
                                                    fontSize: "12px",
                                                    color: "#0d6efd",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                    margin: 0,
                                                  }}
                                                  title={val.ProposalReport}
                                                >
                                                  {val.ProposalReport}
                                                </p>
                                              </div>
                                            </>

                                          )
                                          :
                                          (
                                            <div className='m-auto' style={{ display: "flex", alignItems: "center", gap: "0.20rem", justifyContent: "center", width: "fit-content" }}>
                                              <img src="/No-File32.png" alt="no file" style={{ width: "1.3rem", height: "1.3rem" }} />
                                              <span className='text-danger fw-bold'>No File</span>
                                            </div>
                                          )
                                      }
                                      </td>
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={10} style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                    No Data Found !!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Footer / Pagination */}
                        <div className='col-12 mt-4'>
                          <div className="row">
                            <div className='col-6'>
                              <p className="text-gray-600" style={{ fontSize: "14px" }}>
                                {tableContainer.length > 0
                                  ? `Showing ${indexOfFirstBill + 1} to ${Math.min(indexOfLastBill, tableContainer.length)} of ${tableContainer.length} entries`
                                  : "Showing 0 to 0 of 0 entries"}
                              </p>
                            </div>

                            <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                              <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                &laquo;
                              </button>
                              <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                &lt;
                              </button>
                              <button
                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>
                                {currentPage}
                              </button>
                              <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                &gt;
                              </button>
                              <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                &raquo;
                              </button>
                            </div>
                          </div>


                        </div >

                      </div>
                    </div>
                  )}

                </div >
              </div >
            </div >
          }

          {
            selectedProposals.length > 0 &&
            (
              <div className="col-12" style={{ marginBottom: "50px" }}>
                <div className="col-12">
                  <div className="row" style={{ justifyContent: "center" }}>

                    <div className="col-4 py-2" style={{ fontSize: "14px", border: "1px solid #5760AD", fontWeight: "600", backgroundColor: "#C4DFEB" }}>
                      <div className="row">
                        <div className="col-5 my-auto">
                          <p className='my-auto'>Proposal Count : </p>
                        </div>
                        <div className="col-6 my-auto">
                          <p className='my-auto'><b>{selectedProposals.length || 0}</b></p>
                        </div>
                      </div>
                    </div>


                    <div className="col-4 py-2" style={{ fontSize: "14px", border: "1px solid #5760AD", fontWeight: "600", backgroundColor: "#C4DFEB" }}>
                      <div className="row">
                        <div className="col-5 my-auto">
                          <p className='my-auto'>Total Amount : </p>
                        </div>
                        <div className="col-7 my-auto">
                          <p className='my-auto'><b>{totalAmount || 0}</b></p>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>


              </div>
            )
          }

        </div >
      </div>
    </>
  );
};

export default CreateProject;